import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidThumbsUpIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.3 10.1C20.7 9.4 19.9 9 19 9h-4.6l.6-1.4c.8-2.1-.3-4.5-2.4-5.3-.5-.2-1-.3-1.5-.3-.4 0-.8.2-.9.6L7.3 9H5c-1.7 0-3 1.3-3 3v7c0 1.7 1.3 3 3 3h12.7c1.5 0 2.7-1 3-2.5l1.3-7c.1-.8-.1-1.7-.7-2.4ZM7 20H5c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h2v9Z"/>
  </SvgIcon>
}

export default SolidThumbsUpIcon
